import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentTemplate, TitleHeader } from 'web-library';
import AdminAnnouncementsConfigs from '../../../modules/admin/components/AdminAnnouncementsConfigs';

const AnnouncementsConfiguration = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader title={t('admin->>AnnouncementsConfiguration.Header')} />

      <ContentTemplate type="full">
        <AdminAnnouncementsConfigs />
      </ContentTemplate>
    </>
  );
};

export default AnnouncementsConfiguration;
